import type { SVGProps } from "react";
import { memo } from "react";
const QuickSight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#4D27A8" />
        <stop offset="100%" stopColor="#A166FF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="url(#prefix__a)"
        d="M0 0h80v80H0z"
        transform="translate(.121)"
      />
      <path
        fill="#FFF"
        d="M65 24c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2 2-.897 2-2M42 47c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2 2-.897 2-2m-2-14c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2M19 53c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2 2-.897 2-2m48-29c0 2.206-1.794 4-4 4a3.97 3.97 0 0 1-2.243-.691L43.415 44.948c.363.602.585 1.299.585 2.052 0 2.206-1.794 4-4 4s-4-1.794-4-4c0-1.858 1.279-3.411 3-3.858v-8.284a4 4 0 0 1-1.615-.856l-17.01 16.872c.391.617.625 1.343.625 2.126 0 2.206-1.794 4-4 4s-4-1.794-4-4 1.794-4 4-4c.696 0 1.342.195 1.912.509L36.241 32.32A4 4 0 0 1 36 31c0-2.206 1.794-4 4-4s4 1.794 4 4c0 1.858-1.279 3.411-3 3.858v8.284c.351.091.68.23.986.407l17.457-17.757A3.95 3.95 0 0 1 59 24c0-2.206 1.794-4 4-4s4 1.794 4 4m-50-7h46v1h2v-2a1 1 0 0 0-1-1H16a1 1 0 0 0-1 1v31h2zm46 13h2v34a1 1 0 0 1-1 1H16a1 1 0 0 1-1-1v-5h2v4h46z"
      />
    </g>
  </svg>
);
const Memo = memo(QuickSight);
export default Memo;
